import { apolloQueryWrapper } from '@/shared/api';
import HOLTER_EVENTS_DAILY_COUNT_QUERY from '@/entities/event/api/queries/holterEventsDailyCount';
import type {
  HolterEventsDailyCountQuery,
  HolterEventsDailyCountQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterEventsDailyCount = {
  isSuccess: boolean;
  message: string;
  eventCounts: { date: string; count: number }[];
};

// TODO(ts): typed as the HolterEventsFilter GraphQL input once its server-side shape is documented
/**
 * Loads the per-day Holter event counts behind the daily summary. Runs the holterEventsDailyCount query with caching on and returns its eventCounts, throwing the server message when isSuccess is false.
 *
 * @param filter - GraphQL filter narrowing the counts to a study and time range.
 * @param key - Cancellation key identifying this request.
 * @param needCancel - Whether an in-flight request under the same key is cancelled first.
 * @returns A promise resolving to the per-day event counts.
 */
const fetchHolterEventsDailyCount = async (filter: any, key?: string | null, needCancel = true) => {
  const result = await apolloQueryWrapper<
    HolterEventsDailyCountQuery,
    HolterEventsDailyCountQueryVariables
  >({
    options: {
      query: HOLTER_EVENTS_DAILY_COUNT_QUERY,
      variables: {
        filter,
      },
    },
    isUsingCache: true,
    key,
    needCancel,
  });
  const { data } = result;
  const { holterEventsDailyCount } = data;
  if (holterEventsDailyCount?.isSuccess) {
    return holterEventsDailyCount.eventCounts;
  }
  throw new Error(holterEventsDailyCount?.message);
};

export default fetchHolterEventsDailyCount;
